<template>
  <div class="like-wrap pointer" @click.stop="handleLike">
    <fps-icon v-if="!islike" type="like" class="like-icon" :size="size" />
    <fps-icon v-else type="like2" :class="['like-icon', 'is-like', clickLike && 'click-like']" :size="size" />
  </div>
</template>

<script>
export default {
  model: {
    prop: 'like',
    event: 'change',
  },
  props:{
    momentId: {
      type: Number,
      default: () => {
        return 3
      }
    },
    like: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: '18'
    },
  },
  data() {
    return {
      islike: false,
      clickLike: false,
    }
  },
  watch: {
    like(like) {
      this.islike = like
    },
  },
  created() {
    this.islike = this.like
  },
  methods: {
    handleLike() {
      if (!this.loading) {
        this.loading = true
        const like = !this.islike
        if (like) {
          this.clickLike = true
        } else {
          this.clickLike = false
        }
        this.$emit('change', like)
        this.$http.post('/moment/moment/like', {
          like,
          momentId: this.momentId
        }).then(() => {
          this.loading = false
        }).catch(err => {
          if (!like) {
            this.clickLike = true
          } else {
            this.clickLike = false
          }
          this.$emit('change', !like)
          Error(err)
          this.loading = false
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @keyframes zoomfn {
    0% { transform: scale(1); }
    50% { transform: scale(1.2); }
    85% { transform: scale(1); }
    100% { transform: scale(1); }
  }
  .like-wrap {
    .like-icon {
      display: inline-block;
      color: #636D86;
    }
    .is-like {
      color: #FA006E;
    }
    .click-like {
      animation: zoomfn .5s ease-in-out 1;
    }
  }
</style>
